import { IPrescriptionOptions } from '@/components/PrescriptionFormV2/types';

/**
 * 处理处方数据
 * @param data
 * @returns
 */
export const handlerPrescriptionData = (data: any) => {
  const presData = { ...data };
  const option = {};
  const { prescription } = data;
  if (prescription) {
    const excludeKey = ['coating_id', 'lens_id', 'od_axis', 'os_axis', 'name']; // 不需要转换
    const keys = Object.keys(prescription);
    for (const key of keys) {
      if (isNaN(parseFloat(prescription[key])) || excludeKey.includes(key)) {
        option[key] = `${prescription[key]}`;
      } else {
        option[key] = `${parseFloat(prescription[key]).toFixed(2)}`;
      }
    }
    presData.prescription = option;
  }
  return presData;
};

export const hasPrism = (_prescriptionOptions: IPrescriptionOptions): boolean => {
  return !!(
    (_prescriptionOptions.od_pv && _prescriptionOptions.od_pv !== '0.00') ||
    (_prescriptionOptions.os_pv && _prescriptionOptions.os_pv !== '0.00') ||
    (_prescriptionOptions.od_pv_r && _prescriptionOptions.od_pv_r !== '0.00') ||
    (_prescriptionOptions.os_pv_r && _prescriptionOptions.os_pv_r !== '0.00')
  );
};

export const hasTwoPd = (_prescriptionOptions: IPrescriptionOptions): boolean => {
  // TODO 为了适配处方识别识别出双pd其中一个pd的情况，这里对双PD做了修改。
  // 二期时候的定义是：!!(_prescriptionOptions.pd_l && _prescriptionOptions.pd_r)
  return !!((_prescriptionOptions.pd_l || _prescriptionOptions.pd_r) && !_prescriptionOptions.pd);
};
